import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {customerFormFields, customerResourceType} from "./configs/customer-modal-config";
import {FormGroup} from "@angular/forms";
import {CustomerData, CustomerDialogData, CustomerFormField} from "./types/customer-modal.types";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {CustomerModalService} from "./services/customer-modal.service";
import {CurrentCustomerModalComponent} from "./components/current-customer-modal/current-customer-modal.component";
import {NewCustomerModalComponent} from "./components/new-customer-modal/new-customer-modal.component";
import {LoadingService} from "../../../services/loading.service";
import {LoaderComponent} from "../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-customer-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    CurrentCustomerModalComponent,
    NewCustomerModalComponent,
    LoaderComponent
  ],
  templateUrl: './customer-modal.component.html',
  styleUrl: './customer-modal.component.scss',
  providers: [ LoadingService ]
})
export class CustomerModalComponent extends BaseModalComponent {
  public customerDialogData = inject<CustomerDialogData>(MAT_DIALOG_DATA);
  private customerModalService: CustomerModalService = inject(CustomerModalService);

  public customerFormGroup: FormGroup = new FormGroup({});
  public hasCustomer: boolean = false;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(customerResourceType.path);
    this.initForm();
    this.hasCustomer = !!this.customerDialogData.customer.id;
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(customerResourceType.path);
  }

  public attachOrDetachCustomer(customer: CustomerData | null): void {
    this.customerDialogData.customer.id = customer ? customer.id : null;
    this.customerDialogData.parentData['customer'] = this.customerModalService.updateCustomerDataInTable(customer?.id || null);
    this.hasCustomer = !!customer;
    customer ?
      this.customerFormGroup.patchValue(customer) :
      this.customerFormGroup.reset();
  }

  public updateLoading(isLoading: boolean): void {
    this.loadingService.setIsLoadingState(isLoading);
  }

  private initForm(): void {
    this.customerFormGroup = this.baseModalService.getFormGroup< CustomerFormField>(customerFormFields);
  }
}
